import CLTooltip from '@/components/utils/tooltip';
import { downloadFile } from '@/services/axios/dowload-file';
import { RunComponentCommonProps } from '@/types/run-components.type';

export default function RunFileGroupComponent({
  componentMapping
}: RunComponentCommonProps) {
  return (
    <div>
      {componentMapping?.component_file_group?.component_files &&
        componentMapping?.component_file_group?.component_files?.length > 0 && (
          <div className="flex flex-col gap-2">
            {componentMapping?.component_file_group?.component_files.map(
              (componentFile, index) => (
                <div
                  key={index}
                  className="flex max-w-full md:max-w-[65%] items-center justify-between border border-gray-400 rounded-md bg-white"
                >
                  {/* SVG Icon */}
                  <div className="flex items-center p-2 border-r border-gray-400 rounded-l-md bg-[#c8f7c5]">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.502 1.5V4.5C10.502 4.89782 10.66 5.27936 10.9413 5.56066C11.2226 5.84196 11.6041 6 12.002 6H15.002M7.50195 6.75H6.00195M12.002 9.75H6.00195M12.002 12.75H6.00195M11.252 1.5H4.50195C4.10413 1.5 3.7226 1.65804 3.44129 1.93934C3.15999 2.22064 3.00195 2.60218 3.00195 3V15C3.00195 15.3978 3.15999 15.7794 3.44129 16.0607C3.7226 16.342 4.10413 16.5 4.50195 16.5H13.502C13.8998 16.5 14.2813 16.342 14.5626 16.0607C14.8439 15.7794 15.002 15.3978 15.002 15V5.25L11.252 1.5Z"
                        stroke="black"
                        stroke-opacity="0.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>

                  {/* File Name */}
                  <div
                    className="flex-1 pl-2 text-left truncate"
                    title={componentFile?.org_file?.file?.name}
                  >
                    {componentFile?.org_file?.file?.name}
                  </div>

                  {/* Download Button */}
                  <div className="pr-2">
                    {componentFile?.url && (
                      <CLTooltip content="Download" position="right">
                        <button
                          className=" bg-[#ffa726] p-0.5 rounded-full"
                          onClick={() => {
                            downloadFile(
                              componentFile.url as string,
                              componentFile?.org_file?.file?.name
                            );
                          }}
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.00195 8.5V1.5"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M3.00195 5.5L6.00195 8.5L9.00195 5.5"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M9.50195 10.5H2.50195"
                              stroke="black"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </CLTooltip>
                    )}
                  </div>
                </div>
              )
            )}
          </div>
        )}
    </div>
  );
}
